'use client';

// import { useEffect } from 'react';
import { useScrollPosition } from '@/app/utils/useScrollPosition';
import Header from './header';

export default function ReactiveHeader(props: { sticky?: boolean }) {
  const scrollPosition = useScrollPosition();

  // useEffect(() => console.log(scrollPosition), [scrollPosition]);

  const { sticky = false } = props;

  return <Header sticky={sticky} isScrolled={scrollPosition > 460} />;
}
